import React from 'react'
import PrintItem from './PrintItem'

class PrintItems extends React.Component {
    _renderItems = (item, rest) => {
        const {products} = item
        const countProducts = products.length

        return products.map((product, index) => {
            return <PrintItem {...rest} key={product._id} item={item} product={product}
                              pos={`${index + 1}/${countProducts}`}/>
        })
    }

    _parsePos = (barcodeNumber) => {
        const codes = barcodeNumber.split('_')

        if (codes.length < 2) return 0

        if (isNaN(codes[1])) return 0

        return codes[1]
    }

    render() {
        const {item, barcodeNumber, ...rest} = this.props
        const {products} = item
        const pos = this._parsePos(barcodeNumber)

        return (
            <div className='PrintItems'>
                {
                    pos > 0 && pos <= products.length ?
                        <PrintItem
                            {...rest}
                            barcodeNumber={barcodeNumber}
                            item={item}
                            product={products[pos - 1]}
                            pos={`${pos}/${products.length}`}
                        /> : this._renderItems(item, {...rest, barcodeNumber})
                }
            </div>
        )
    }
}

export default PrintItems
